import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="container py-5">
      <div className="d-flex flex-column align-items-center text-center">
        <h1 className="display-3 fw-bold">404</h1>
        <p className="lead">Strona nie została znaleziona.</p>
        <p className="text-muted">Sprawdź adres lub wróć do strony głównej.</p>
        <div className="d-flex gap-2 mt-3">
          <Link to="/" className="btn btn-outline-primary">Strona główna</Link>
          <Link to="/list" className="btn btn-secondary">Lista materiałów</Link>
        </div>
      </div>
    </div>
  );
}
